import ArrowNext from '@pe-libs/react-components/build/components/PeIcons/ArrowNext.svg';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC, useEffect, useState } from 'react';
import useRedirect from '#hooks/useRedirect';
import messages from './messages';
import useStyles from './styles';

type Props = {
  handleChangePage: (event: React.ChangeEvent<unknown>, nextPage: number) => Promise<void>;
};

const Banner: FC<Props> = ({ handleChangePage }) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const { urlToLivePage } = useRedirect();
  const [image, setImage] = useState('');

  useEffect(() => {
    import(
      `#assets/images/expertDirectory/signupBanner/${Math.floor(Math.random() * 7) + 1}.jpg`
    ).then((img: { default: string }) => setImage(img.default));
  }, [handleChangePage]);

  return (
    <PeLink
      href={urlToLivePage('register')}
      target="_blank"
      title={formatMessage(messages.bannerHoverTitle)}
      className={styles.banner}
    >
      <div className={styles.bannerImage} style={{ backgroundImage: `url(${image})` }} />
      <div className={styles.bannerContent}>
        <div className={styles.bannerLeftContent}>
          <PeTypography variant="h5" className={styles.bannerTitle}>
            {formatMessage(messages.bannerTitle)}
          </PeTypography>
          <PeTypography variant="body1">{formatMessage(messages.bannerDesc)}</PeTypography>
        </div>
        <div className={styles.bannerIcon}>
          <ArrowNext />
        </div>
      </div>
    </PeLink>
  );
};

export default Banner;
